module.exports = __webpack_public_path__ + "static/img/question3-2.529eb55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/question3-2.png
// module id = M2CS
// module chunks = 1